import api from './api';

export interface DHSComponent {
  _id: string;
  name: string;
  acronym?: string;
  category: 'Component' | 'Directorate' | 'Office';
  description?: string;
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateDHSComponent {
  name: string;
  acronym?: string;
  category: 'Component' | 'Directorate' | 'Office';
  description?: string;
  order?: number;
  isActive?: boolean;
}

export interface UpdateDHSComponent extends Partial<CreateDHSComponent> {}

const base = '/dhs-components';

const dhsComponentsService = {
  async list(q?: string): Promise<DHSComponent[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as DHSComponent[];
  },
  async create(payload: CreateDHSComponent): Promise<DHSComponent> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as DHSComponent;
  },
  async update(id: string, payload: UpdateDHSComponent): Promise<DHSComponent> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as DHSComponent;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default dhsComponentsService;
